const style = {
  span: {
    color: `black`
  },
  headerSpan: {
    color: `black`
  },
  spanCenter: {
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/RevenueTable/style/ColorBlind/item.js